<template>
	<div :class="[$route.name === 'eoi' || $route.name === 'thank-you' ? 'eoi-page-heading' : 'page-heading']">
		<div class="o-container o-container--tablet-gutter page-heading__inner"
         :class="[$route.name === 'eoi' || $route.name === 'thank-you' ? 'eoi-page-heading__inner' : 'page-heading__inner']"
    >
			<h1 v-if="$route.name === 'subscriptions'" class="page-heading__title">Manage Subscriptions</h1>
			<h1 v-else-if="$route.name !== 'eoi' && $route.name !== 'thank-you'" class="page-heading__title">My account</h1>
		</div>
	</div>
</template>

<script>
	
	export default {}
</script>

<style lang="scss">
	@import "~sass/_config.scss";
	@import '~sass/_variables.scss';
	@import "~sass/mixins/_media-query.scss";

	.page-heading {
		background-size: cover;
		background-position: 50% 50%;
		background-image: url('../../../img/PageHeading/img--bg4.png');

		&__inner {
			min-height: 100px;
			display: flex !important; // Force override of o-container display: block
			align-items: center;
			justify-content: flex-start;
		}

		&__title {
			font-size: 24px;
			line-height: 40px;
			font-weight: 600;
			color: $col-neutral--0;
		}

		@include mq(tablet) {
			&__inner {
				min-height: 165px;
			}

			&__title {
				font-size: 34px;
			}
		}

		@include mq(largeTablet) {
			&__inner {
				min-height: 200px;
			}
		}
	}

  .eoi-page-heading {
    background-size: cover;
    background-position: 50% 50%;
    background-image: url('../../../img/eoi/eoi-img--bg.png');

    &__inner {
      min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    &__title {
      font-size: 24px;
      line-height: 40px;
      font-weight: 600;
      color: $col-neutral--0;
    }

    @include mq(tablet) {
      &__inner {
        min-height: 110px;
      }

      &__title {
        font-size: 34px;
      }
    }

    @include maxq(mobile) {
      &__inner {
        min-height: 45px;
      }
    }

    @include mq(mobile) {
      &__inner {
        min-height: 69px;
      }
    }

    @include mq(largeMobile) {
      &__inner {
        min-height: 93px;
      }
    }

    @include mq(tablet) {
      &__inner {
        min-height: 118px;
      }
    }

    @include mq(largeTablet) {
      &__inner {
        min-height: 138px;
      }
    }

    @include mq(desktop) {
      &__inner {
        min-height: 155px;
      }
    }

    @include mq(largeDesktop) {
      &__inner {
        min-height: 200px;
      }
    }

    @include mq(extraLargeDesktop) {
      &__inner {
        min-height: 229px;
      }
    }

    @include mq(tvScreen) {
      &__inner {
        min-height: 300px;
      }
    }

    @include mq(largeTvScreen) {
      &__inner {
        min-height: 400px;
      }
    }
  }

</style>